import { React, useState } from "react";

import Aside from "../../components/Aside/Aside";
import NotificationDialog from "../../components/dialogs/NotificationDialog/NotificationDialog";
import SideNav from "../../components/SideNav/SideNav";
// import Tooltip from "react-simple-tooltip";

import "./TemplatePage.css";

const TemplatePage = () => {
  const [isOPenNotification, setIsOpenNotification] = useState(false);
//   <Tooltip
//   content="Testing"
//   background="dodgerblue"
//   color="white"
//   border="white"
//   padding="10"
//   fontSize="0.8rem"
//   fadeDuration="100"
// ></Tooltip>
  return (
    <div className="al-body">
      <SideNav activePage="TemplatePage" />
      <div className="al-main">
        <h1>TemplatePage</h1>
      </div>
      <Aside
        expandNotifications={() => {
          setIsOpenNotification(true);
        }}
      />

      <NotificationDialog
        onClose={() => {
          setIsOpenNotification(false);
        }}
        isOpen={isOPenNotification}
      />
    </div>
  );
};

export default TemplatePage;
